var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"small":"","color":_vm.getServiceIconColor(_vm.service)}},[_vm._v(_vm._s(_vm.getServiceIcon(_vm.service)))])}
var staticRenderFns = []

export { render, staticRenderFns }